export const DELETE = 'delete';
export const RESOLVE = 'resolve';
